import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Field2 as Field,
  color,
} from 'vibeguide';
import {
  GridLegacy as Grid,
} from '@mui/material';
import './Script.scss';

class Script extends PureComponent {
  /**
   * When a field is changed
   */
  onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      onUpdate,
    } = this.props;

    onUpdate({
      [name]: value,
    });
  };

  /**
   * Set the script type to help
   */
  setScriptTypeHelp = () => {
    const {
      onUpdate,
    } = this.props;

    onUpdate({
      readType: 'interpret',
    });
  };

  /**
   * Set the script type to exact
   */
  setScriptTypeExact = () => {
    const {
      onUpdate,
    } = this.props;

    onUpdate({
      readType: 'exact',
    });
  };

  render() {
    const {
      script,
      readType,
      type,
      instructions,
      scriptVisible,
      disableScript,
      disableInstructions,
      hasFile,
    } = this.props;

    return (
      <div className="Script">
        <Grid
          className="row"
          spacing={2}
          container
        >
          <Grid xs={6} item>
            <Field
              type="radio"
              label="Help me with my script"
              radioProps={{
                selected: readType === 'interpret',
              }}
              style={{
                padding: '8px 16px',
                border: readType === 'interpret'
                  ? `1px solid ${color.primary}`
                  : '1px solid transparent',
                backgroundColor: readType === 'interpret'
                  ? color.yellow16
                  : 'transparent',
              }}
              disabled={disableScript}
              onClick={this.setScriptTypeHelp}
            />
          </Grid>

          <Grid xs={6} item>
            <Field
              type="radio"
              label="Use my exact script"
              radioProps={{
                selected: readType === 'exact',
              }}
              style={{
                padding: '8px 16px',
                border: readType === 'exact'
                  ? `1px solid ${color.primary}`
                  : '1px solid transparent',
                backgroundColor: readType === 'exact'
                  ? color.yellow16
                  : 'transparent',
              }}
              disabled={disableScript}
              onClick={this.setScriptTypeExact}
            />
          </Grid>

          <Grid xs={12} item>
            <Field
              className="script-textarea"
              type="textarea"
              label="Script"
              name="script"
              placeholder="Message script..."
              value={script}
              tabIndex={10}
              disabled={disableScript}
              required={!hasFile && !disableScript && scriptVisible && type !== 'ext-ad'}
              onChange={this.onChange}
            />
          </Grid>

          <Grid xs={12} item>
            <Field
              className="special-instructions-textarea"
              type="textarea"
              label="Special Instructions"
              name="instructions"
              placeholder="(Optional)"
              value={instructions}
              tabIndex={11}
              disabled={disableInstructions}
              onChange={this.onChange}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

Script.propTypes = {
  script: PropTypes.string,
  readType: PropTypes.oneOf([
    'interpret',
    'exact',
  ]),
  type: PropTypes.string,
  instructions: PropTypes.string,
  scriptVisible: PropTypes.bool,
  disableScript: PropTypes.bool,
  disableInstructions: PropTypes.bool,
  hasFile: PropTypes.bool,
  onUpdate: PropTypes.func,
};

Script.defaultProps = {
  script: '',
  readType: 'interpret',
  type: '',
  instructions: '',
  scriptVisible: false,
  disableScript: false,
  disableInstructions: false,
  hasFile: false,
  onUpdate: () => {},
};

export default Script;
